import _slicedToArray from "E:\\Agents\\Agent-02\\_work\\1\\s\\src\\apps\\dotsite\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/slicedToArray";
import React from 'react';
import { ReactComponent as PlusImg } from '../../../resources/icons/gray-plus.svg';
import { ReactComponent as MinusImg } from '../../../resources/icons/gray-minus.svg';
import grayPlusImg from '../../../resources/icons/gray-plus.svg';
import bluePlusImg from '../../../resources/icons/blue-plus.svg';
import grayMinusImg from '../../../resources/icons/gray-minus.svg';
import blueMinusImg from '../../../resources/icons/blue-minus.svg';
import { tealiumClickFunc, tealiumMergeClickData } from '../../../utils/tealium';
import { get, getDictionaryItem, canUseDOM, pathJoin, getMediaHost, injectImageResolution } from '../../../utils';
import LazyPicture from '../../atoms/LazyPicture';
import ScrollAnimation from 'react-animate-on-scroll';
import { useLocation } from 'react-router-dom';
var getFormatedDate = function getFormatedDate(date, lang) {
  return new Date(date).toLocaleDateString(lang === 'en' ? 'en-GB' : lang, {
    day: 'numeric',
    month: 'long',
    year: 'numeric'
  });
};
var convertDate = function convertDate(startDate, endDate) {
  var lang = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'en-GB';
  var date = [];
  if (startDate) {
    date.push(getFormatedDate(startDate, lang));
  }
  if (endDate) {
    date.push(getFormatedDate(endDate, lang));
  }
  return date.join(' - ');
};
var socialIconsSize = {
  facebook: {
    width: '10px'
  },
  linkedin: {
    width: '24px'
  },
  email: {
    width: '25px'
  },
  twitter: {
    width: '21px'
  },
  whatsapp: {
    width: '27px'
  }
};
var svgClass = {
  'Listing deal': 'blue',
  'Listing vendor': 'blue',
  'Listing trade event': 'gray'
};
var typesDealsFields = {
  // Leisure
  'Listing deal': {
    location: 'dealLocation',
    locationTag: 'locationtags',
    dealtypetags: 'dealtypetags',
    categorytags: 'categoryTags',
    category: 'category',
    phone: 'phone',
    email: 'email',
    moreinfo: 'moreinfo',
    partner: 'partners',
    promoCode: 'redemptionCode',
    isFeatured: 'dealfeatured',
    featuredColor: '#C22C91',
    termsandconditions: 'termsandconditions',
    bookNow: 'bookLink',
    bookNowLabelField: 'Book now',
    bookNowColor: '#007CBA',
    labelHoverColor: 'blue'
  },
  // Buisiness
  'Listing vendor': {
    location: 'locationtags',
    event: 'eventtags',
    dealtypetags: 'dealtypetags',
    categorytags: 'categoryTags',
    category: 'category',
    eventsizetags: 'eventsizetags',
    services: 'servicetags',
    marketspecialisation: 'marketspecialisationtags',
    phone: 'phone',
    email: 'email',
    moreinfo: 'moreinfo',
    isFeatured: 'dealfeatured',
    featuredColor: '#17808E',
    languages: 'languagetags',
    bookNow: 'listingvendorswebsite',
    bookNowLabelField: 'Visit website',
    bookNowColor: '#007CBA',
    labelHoverColor: 'blue'
  },
  // Trade
  'Listing trade event': {
    category: 'category',
    categorytags: 'categoryTags',
    location: 'locationtags',
    dealtypetags: 'dealtypetags',
    standnumber: 'standnumber',
    phone: 'phone',
    email: 'email',
    moreinfo: 'moreinfo',
    isFeatured: 'dealfeatured',
    featuredColor: '#007CBA',
    bookNow: 'registerurl',
    bookNowLabelField: 'Register now',
    bookNowColor: '#6D6E6E',
    labelHoverColor: 'gray'
  }
};
export var TermsAndConditions = function TermsAndConditions(_ref) {
  var termsandconditions = _ref.termsandconditions,
    label = _ref.label,
    color = _ref.color,
    expandCollapseAnalytics = _ref.expandCollapseAnalytics,
    params = _ref.params,
    englishTitle = _ref.englishTitle;
  var _React$useState = React.useState(true),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    isHidden = _React$useState2[0],
    setHidden = _React$useState2[1];
  var isGrayColor = color === 'gray' ? '' : 'deals__details-item--icon';

  //  const plus = isGrayColor ? grayPlusImg: bluePlusImg;
  //const minus = isGrayColor ? grayMinusImg : blueMinusImg;

  return /*#__PURE__*/React.createElement("div", {
    className: "deals__terms-and-conditions-box"
  }, /*#__PURE__*/React.createElement("div", {
    className: 'deals__details-item deals__terms-and-conditions',
    onClick: function onClick() {
      setHidden(!isHidden);
      tealiumClickFunc(tealiumMergeClickData(expandCollapseAnalytics, params), isHidden ? "Show: ".concat(englishTitle) : "Hide:  ".concat(englishTitle));
    }
  }, /*#__PURE__*/React.createElement("span", {
    tabIndex: 0,
    onKeyPress: function onKeyPress(event) {
      if (event.key === 'Enter' || event.key === 'NumpadEnter') {
        event.preventDefault();
        setHidden(!isHidden);
        tealiumClickFunc(tealiumMergeClickData(expandCollapseAnalytics, params), isHidden ? "Show: ".concat(englishTitle) : "Hide:  ".concat(englishTitle));
      }
    },
    className: "bold-text terms-and-conditions-label hover-label-color-".concat(color)
  }, label), isHidden ? /*#__PURE__*/React.createElement(PlusImg, {
    onKeyPress: function onKeyPress(event) {
      if (event.key === 'Enter' || event.key === 'NumpadEnter') {
        event.preventDefault();
        setHidden(!isHidden);
        tealiumClickFunc(tealiumMergeClickData(expandCollapseAnalytics, params), isHidden ? "Show: ".concat(englishTitle) : "Hide:  ".concat(englishTitle));
      }
    },
    tabIndex: 0,
    className: "".concat(isGrayColor, " datails-expand-img")
  }) : /*#__PURE__*/React.createElement(MinusImg, {
    tabIndex: 0,
    onKeyPress: function onKeyPress(event) {
      if (event.key === 'Enter' || event.key === 'NumpadEnter') {
        event.preventDefault();
        setHidden(!isHidden);
        tealiumClickFunc(tealiumMergeClickData(expandCollapseAnalytics, params), isHidden ? "Show: ".concat(englishTitle) : "Hide:  ".concat(englishTitle));
      }
    },
    className: "".concat(isGrayColor, " datails-expand-img")
  })), !isHidden && /*#__PURE__*/React.createElement("div", {
    className: "",
    dangerouslySetInnerHTML: {
      __html: termsandconditions
    }
  }));
};
export var DealBlock = function DealBlock(_ref2) {
  var event = _ref2.event,
    lang = _ref2.lang,
    route = _ref2.route,
    params = _ref2.params,
    fields = _ref2.fields,
    hostLink = _ref2.hostLink,
    analytics = _ref2.analytics,
    socialSharing = _ref2.socialSharing,
    socialAnalytics = _ref2.socialAnalytics;
  var imgAlt = get(event, 'title');
  var imgSrc = injectImageResolution("".concat(pathJoin([getMediaHost(), event.image])), 440, 440);
  var _React$useState3 = React.useState(true),
    _React$useState4 = _slicedToArray(_React$useState3, 2),
    isHidden = _React$useState4[0],
    setHidden = _React$useState4[1];
  var expandCollapseAnalytics = analytics.expandCollapseAnalytics,
    buttonClickAnalytics = analytics.buttonClickAnalytics;
  var eventType = event.type.toString();
  var locationURL = useLocation();
  var fNames = typesDealsFields[eventType];
  if (!fNames) {
    return null;
  }
  var dictionary = get(fields, 'data.dictionary');
  var featuredText = getDictionaryItem(dictionary, 'Featured') || 'featured';
  var eventsText = getDictionaryItem(dictionary, 'Events') || 'Events:';
  var categoryText = getDictionaryItem(dictionary, 'Category') || 'Category:';
  var bookingcodeText = getDictionaryItem(dictionary, 'Booking code') || 'Booking code:';
  var eventSizeText = getDictionaryItem(dictionary, 'Event size') || 'Event size:';
  var servicesText = getDictionaryItem(dictionary, 'Services') || 'Services:';
  var maketSpecialisationText = getDictionaryItem(dictionary, 'Maket specialisation') || 'Maket specialisation:';
  var languagesText = getDictionaryItem(dictionary, 'Languages') || 'Languages:';
  var bookNowText = getDictionaryItem(dictionary, fNames.bookNowLabelField) || 'Book now';
  var priorBookNowText = get(event, 'dealBookLabel') || bookNowText;
  var detailsText = getDictionaryItem(dictionary, 'Details') || 'Details listing';
  var locationsText = getDictionaryItem(dictionary, 'Locations') || 'Locations:';
  var locationListText = getDictionaryItem(dictionary, 'LocationsList') || 'Location:';
  var dealtypetagsText = getDictionaryItem(dictionary, 'Deal type') || 'Deal type:';
  var partnerText = getDictionaryItem(dictionary, 'Partner') || 'Partner:';
  var promoCodeText = getDictionaryItem(dictionary, 'Promo code') || 'Promo code:';
  var standNumberText = getDictionaryItem(dictionary, 'Stand number') || 'Stand number:';
  var emailText = getDictionaryItem(dictionary, 'Email') || 'Email:';
  var phoneText = getDictionaryItem(dictionary, 'Phone') || 'Phone:';
  var aboutText = getDictionaryItem(dictionary, 'About') || 'About:';
  var termsAndConditionsText = getDictionaryItem(dictionary, 'Terms and Conditions') || 'Terms and Conditions';
  var moreinfoText = getDictionaryItem(dictionary, 'More info') || 'More info:';
  var BASE_URL = String(process.env.REACT_APP_MEDIA_HOST || '');
  var title = get(socialSharing, 'title.jss.value');
  var likeButtonsTitle = get(socialSharing, 'likeButtonsTitle.jss.value');
  var socialLinks = get(socialSharing, 'socialLinks.values');
  var location = event[fNames.location];
  var locationTag = event[fNames.locationTag];
  var dealtypetags = event[fNames.dealtypetags];
  var partner = event[fNames.partner];
  var promoCode = event[fNames.promoCode];
  var isFeatured = event[fNames.isFeatured];
  var featuredColor = "var(--backgroundPrimaryColor, ".concat(fNames.featuredColor, ")");
  var events = event[fNames.event];
  var eventsizetags = event[fNames.eventsizetags];
  var category = event[fNames.category];
  var categorytags = event[fNames.categorytags] || event.categorytags;
  var bookNow = event[fNames.bookNow];
  var bookNowColor = fNames.bookNowColor;
  var labelHoverColor = fNames.labelHoverColor;
  var marketspecialisation = event[fNames.marketspecialisation];
  var services = event[fNames.services];
  var languages = event[fNames.languages];
  var standnumber = event[fNames.standnumber];
  var phone = event[fNames.phone];
  var email = event[fNames.email];
  var moreinfo = event[fNames.moreinfo];
  var termsandconditions = event[fNames.termsandconditions];
  var qIndex = email ? email.indexOf('?') : -1;
  var fixedEmail = ~qIndex ? email.slice(0, qIndex) : email;
  var featured = isFeatured && featuredColor ? /*#__PURE__*/React.createElement(React.Fragment, null, category && /*#__PURE__*/React.createElement("span", null, ' · '), /*#__PURE__*/React.createElement("span", {
    className: "featured-tag",
    style: {
      color: featuredColor
    }
  }, featuredText)) : '';
  var renderTags = function renderTags() {
    var tags = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
    return tags.map(function (tag, index) {
      return index ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("span", null, ' · '), /*#__PURE__*/React.createElement("span", null, tag)) : /*#__PURE__*/React.createElement("span", null, tag);
    });
  };
  return /*#__PURE__*/React.createElement("div", {
    className: "col-12  deals__item-col",
    style: {
      position: 'relative'
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: "deals__item"
  }, /*#__PURE__*/React.createElement("div", {
    className: "deals__image-wrap"
  }, event.image && /*#__PURE__*/React.createElement(LazyPicture, {
    useEmptyPlaceholder: true,
    hover: true
  }, /*#__PURE__*/React.createElement("source", {
    media: "(min-width: 768px)",
    srcSet: imgSrc
  }), /*#__PURE__*/React.createElement("img", {
    className: "deals__image",
    src: imgSrc,
    alt: imgAlt
  })), isFeatured && /*#__PURE__*/React.createElement("div", {
    className: "ribbon",
    style: {
      backgroundColor: featuredColor
    }
  })), /*#__PURE__*/React.createElement("div", {
    className: "deals__info"
  }, /*#__PURE__*/React.createElement(ScrollAnimation, {
    animateIn: "animate__fadeInUp",
    animateOnce: true,
    duration: 1.15
  }, /*#__PURE__*/React.createElement("div", {
    className: "deals__category"
  }, eventType === 'Listing deal' ? renderTags(event.category) : renderTags(event.visibletags), featured), /*#__PURE__*/React.createElement("div", {
    className: "deals__item-title"
  }, event.title), eventType === 'Listing deal' && /*#__PURE__*/React.createElement("div", {
    className: "deals__tags"
  }, renderTags(event.visibletags)), (event.validTo || event.validFrom) && /*#__PURE__*/React.createElement("div", {
    className: "deals__date-item ".concat(eventType === 'Listing trade event' ? 'deals__date-item-trade' : '')
  }, convertDate(event.validFrom, event.validTo, lang)), /*#__PURE__*/React.createElement("div", {
    className: "deals__details-item"
  }, /*#__PURE__*/React.createElement("button", {
    className: "btn--reset hover-label-color hover-label-color-".concat(labelHoverColor),
    onClick: function onClick() {
      setHidden(!isHidden);
      tealiumClickFunc(tealiumMergeClickData(expandCollapseAnalytics, params), isHidden ? "Show: ".concat(event.englishTitle) : "Hide:  ".concat(event.englishTitle));
    }
  }, detailsText), /*#__PURE__*/React.createElement("button", {
    className: "btn--reset",
    onClick: function onClick() {
      setHidden(!isHidden);
      tealiumClickFunc(tealiumMergeClickData(expandCollapseAnalytics, params), isHidden ? "Show: ".concat(event.englishTitle) : "Hide:  ".concat(event.englishTitle));
    }
  }, labelHoverColor == 'blue' ? /*#__PURE__*/React.createElement("img", {
    className: "datails-expand-img",
    src: isHidden ? bluePlusImg : blueMinusImg
  }) : /*#__PURE__*/React.createElement("img", {
    className: "datails-expand-img",
    src: isHidden ? grayPlusImg : grayMinusImg
  }))), /*#__PURE__*/React.createElement("div", {
    className: "intro-text-block  ".concat(isHidden ? '' : 'expanded')
  }, !isHidden && /*#__PURE__*/React.createElement(React.Fragment, null, events && /*#__PURE__*/React.createElement("div", {
    className: "details-items"
  }, /*#__PURE__*/React.createElement("div", {
    className: "details-item events"
  }, /*#__PURE__*/React.createElement("span", {
    className: "bold-text"
  }, eventsText, " "), /*#__PURE__*/React.createElement("span", null, events.join(', ')))), eventsizetags && /*#__PURE__*/React.createElement("div", {
    className: "eventsizetags"
  }, /*#__PURE__*/React.createElement("span", {
    className: "bold-text"
  }, eventSizeText, " "), /*#__PURE__*/React.createElement("span", null, eventsizetags.join(', '))), services && /*#__PURE__*/React.createElement("div", {
    className: "services"
  }, /*#__PURE__*/React.createElement("span", {
    className: "bold-text"
  }, servicesText, " "), /*#__PURE__*/React.createElement("span", null, services.join(', '))), marketspecialisation && /*#__PURE__*/React.createElement("div", {
    className: "marketspecialisation"
  }, /*#__PURE__*/React.createElement("span", {
    className: "bold-text"
  }, maketSpecialisationText, " "), /*#__PURE__*/React.createElement("span", null, marketspecialisation.join(', '))), languages && /*#__PURE__*/React.createElement("div", {
    className: "languages"
  }, /*#__PURE__*/React.createElement("span", {
    className: "bold-text"
  }, languagesText, " "), /*#__PURE__*/React.createElement("span", null, languages.join(', '))), location && /*#__PURE__*/React.createElement("div", {
    className: "locationtags"
  }, /*#__PURE__*/React.createElement("span", {
    className: "bold-text"
  }, locationsText, " "), /*#__PURE__*/React.createElement("span", null, typeof location === 'string' ? location : location.join(', '))), locationTag && /*#__PURE__*/React.createElement("div", {
    className: "locationtags"
  }, /*#__PURE__*/React.createElement("span", {
    className: "bold-text"
  }, locationListText, " "), /*#__PURE__*/React.createElement("span", null, locationTag.join(', '))), dealtypetags && /*#__PURE__*/React.createElement("div", {
    className: "locationtags dealtypetags"
  }, /*#__PURE__*/React.createElement("span", {
    className: "bold-text"
  }, dealtypetagsText, " "), /*#__PURE__*/React.createElement("span", null, dealtypetags.join(', '))), categorytags && /*#__PURE__*/React.createElement("div", {
    className: "locationtags"
  }, /*#__PURE__*/React.createElement("span", {
    className: "bold-text"
  }, categoryText, " "), /*#__PURE__*/React.createElement("span", null, categorytags.join(', '))), event.bookingcode && /*#__PURE__*/React.createElement("div", {
    className: "details-item promoCode"
  }, /*#__PURE__*/React.createElement("span", {
    className: "bold-text"
  }, promoCodeText, " "), /*#__PURE__*/React.createElement("span", null, event.bookingcode)), standnumber && /*#__PURE__*/React.createElement("div", {
    className: "details-item standnumber"
  }, /*#__PURE__*/React.createElement("span", {
    className: "bold-text"
  }, standNumberText, " "), /*#__PURE__*/React.createElement("span", null, standnumber)), eventType !== 'Listing deal' && phone && /*#__PURE__*/React.createElement("div", {
    className: "details-item phone"
  }, /*#__PURE__*/React.createElement("span", {
    className: "bold-text"
  }, phoneText, " "), /*#__PURE__*/React.createElement("a", {
    className: 'contact-field-link',
    href: "tel:".concat(phone),
    "aria-label": "Phone",
    "aria-labelledby": "phone"
  }, /*#__PURE__*/React.createElement("span", {
    className: 'contact-field'
  }, phone))), event.abouttext && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "bold-text"
  }, aboutText, " "), /*#__PURE__*/React.createElement("div", {
    className: "intro-text deal-text",
    dangerouslySetInnerHTML: {
      __html: event.abouttext
    }
  })), eventType === 'Listing deal' && phone && /*#__PURE__*/React.createElement("div", {
    className: "details-item phone"
  }, /*#__PURE__*/React.createElement("span", {
    className: "bold-text"
  }, phoneText, " "), /*#__PURE__*/React.createElement("a", {
    className: 'contact-field-link desktop',
    href: "tel:".concat(phone),
    "aria-label": "Phone",
    "aria-labelledby": "phone"
  }, /*#__PURE__*/React.createElement("span", {
    className: 'contact-field hide-default-color-link'
  }, phone)), /*#__PURE__*/React.createElement("a", {
    className: 'contact-field-link mobile',
    href: "tel:".concat(phone),
    "aria-label": "Phone",
    "aria-labelledby": "phone"
  }, /*#__PURE__*/React.createElement("span", {
    className: 'contact-field hide-default-color-link'
  }, phone))), email && /*#__PURE__*/React.createElement("div", {
    className: "details-item email"
  }, /*#__PURE__*/React.createElement("span", {
    className: "bold-text"
  }, emailText, " "), /*#__PURE__*/React.createElement("a", {
    className: 'contact-field-link',
    href: "".concat(fixedEmail),
    "aria-label": "Email",
    "aria-labelledby": "Email"
  }, /*#__PURE__*/React.createElement("span", {
    className: 'contact-field hide-default-color-link'
  }, fixedEmail.indexOf('mailto:') === 0 ? fixedEmail.slice(7) : fixedEmail))), moreinfo && /*#__PURE__*/React.createElement("div", {
    className: "details-item moreinfo"
  }, /*#__PURE__*/React.createElement("span", {
    className: "bold-text"
  }, moreinfoText, " "), /*#__PURE__*/React.createElement("div", {
    className: "intro-text moreinfo",
    dangerouslySetInnerHTML: {
      __html: moreinfo
    }
  })), !event.abouttext && /*#__PURE__*/React.createElement("div", {
    className: 'empty-space'
  }), termsandconditions && /*#__PURE__*/React.createElement(TermsAndConditions, {
    label: termsAndConditionsText,
    termsandconditions: termsandconditions,
    color: labelHoverColor,
    expandCollapseAnalytics: expandCollapseAnalytics,
    params: params,
    englishTitle: event.englishTitle
  }))), socialSharing ? !isHidden && Object.keys(socialLinks).length !== 0 && /*#__PURE__*/React.createElement("div", {
    className: "details-item social-sharing ".concat(bookNow ? '' : 'social-sharing--without-cta', " ")
  }, /*#__PURE__*/React.createElement("span", null, title, " "), /*#__PURE__*/React.createElement("div", {
    className: "details-item__link"
  }, socialLinks.map(function (item) {
    var icon = get(item, 'icon.jss.value.src');
    var iconAlt = get(item, 'icon.jss.value.alt');
    var link = get(item, 'link.jss.value', '');
    var svgIcon = get(item, 'svgIcon.jss.value');
    var nameSocial = get(item, 'name');
    var shareURLSearch = canUseDOM ? "".concat(locationURL && encodeURI(locationURL.pathname.replaceAll(' ', '%20')), "/share/").concat(encodeURIComponent(event.urlParameter).replaceAll('%20', '-')) : '';
    var getLinkStyle = function getLinkStyle() {
      for (var key in socialIconsSize) {
        if (nameSocial.toLowerCase().includes(key)) {
          return socialIconsSize[key];
        }
      }
      return {};
    };
    if (link) if (nameSocial.toLowerCase().includes('linkedin')) {
      link = link.replace('title=', 'title%3D');
    }
    link = link.replace('${message}', likeButtonsTitle).replace('${link}', origin + shareURLSearch);
    return /*#__PURE__*/React.createElement("a", {
      href: link,
      target: '_blank',
      style: getLinkStyle(),
      className: "details-item__social-icon",
      "aria-label": "".concat(nameSocial, " | Opens in a new window"),
      onKeyPress: function onKeyPress(event) {
        if (event.key === 'Enter' || event.key === 'NumpadEnter') {
          event.preventDefault();
          event.target.click();
        }
      },
      onClick: function onClick() {
        tealiumClickFunc(tealiumMergeClickData(socialAnalytics, params), "".concat(item.name, " : ").concat(route.name));
      }
    }, svgIcon ? /*#__PURE__*/React.createElement("div", {
      dangerouslySetInnerHTML: {
        __html: svgIcon
      },
      className: "social-sharing__icon social-sharing__icon---svg\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t".concat(svgClass[eventType], " ").concat(item.name.includes('mail') ? 'mail' : '')
    }) : /*#__PURE__*/React.createElement(LazyPicture, {
      useEmptyPlaceholder: true,
      className: nameSocial
    }, /*#__PURE__*/React.createElement("source", {
      media: "(min-width: 768px)",
      srcSet: BASE_URL + icon
    }), /*#__PURE__*/React.createElement("img", {
      className: "social-sharing__icon",
      src: BASE_URL + icon,
      alt: iconAlt,
      title: iconAlt
    })));
  }))) : null, bookNow && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "book-now-button-box"
  }, /*#__PURE__*/React.createElement("a", {
    className: "btn btn-primary book-now-button",
    href: bookNow,
    style: {
      backgroundColor: bookNowColor
    },
    target: '_blank',
    "aria-label": "".concat(priorBookNowText, " | Opens in a new window"),
    onClick: function onClick() {
      return tealiumClickFunc(tealiumMergeClickData(buttonClickAnalytics, params), 'Book now:' + event.englishTitle);
    }
  }, priorBookNowText)))))));
};